export const iconFontAwesomeCodingCubes = (
	<i className="fa-solid fa-cubes"></i>
);
